module.exports = __webpack_public_path__ + "static/ISO9001-6efc9b8203c0cb544bb97a12d2782c03.jpeg";